import React from 'react'
import downloadimg from '../assets/ezgif.com-gif-maker.gif'

export default function DownloadBtn({ loadingreport, downloaddata, downloadexcel}) {
    return (
        !loadingreport
            ? (downloaddata.length > 0
                ? <div className="dwd" onClick={downloadexcel}>
                    <i className="bi bi-download download" style={{ color: '#6a6aea' }}></i>
                </div>
                : <div className="dwd" onClick={downloadexcel}>
                    <i className="bi bi-download download"></i>
                </div>)
            : <div className="dwd" ><img className="gifload" src={downloadimg} alt="loading" /></div>

    )
}
